import * as yup from 'yup';
import { evidenceForm as TEXT } from 'locales/en/dispute';
import { escapedCountryField } from 'utils/transform';

export const PRODUCT_OPTIONS = [
  { label: TEXT.physical, value: 'physical' },
  { label: TEXT.digital, value: 'digital' },
  { label: TEXT.offline, value: 'offline' },
  { label: TEXT.booking, value: 'booking' },
  { label: TEXT.event, value: 'event' },
  { label: TEXT.other, value: 'other' },
];
export const EVIDENCE_OPTIONS = [
  { label: 'Customer communication', value: 'customer_communication' },
  { label: 'Customer signature', value: 'customer_signature' },
  { label: 'Shipping documentation', value: 'shipping_documentation' },
  { label: 'Receipt', value: 'receipt' },
  { label: 'Cancellation policy', value: 'cancellation_policy' },
  { label: 'Refund policy ', value: 'refund_policy' },
  { label: 'Service documentation ', value: 'service_documentation' },
  {
    label: 'Duplicate charge document',
    value: 'duplicate_charge_documentation',
  },
  { label: 'Other', value: 'uncategorized_file' },
];

export const FIELD_NAMES = {
  name: 'name',
  email: 'email',
  address_1: 'address_1',
  address_2: 'address_2',
  postcode: 'postcode',
  city: 'city',
  country: escapedCountryField,

  product: 'product',
  description: 'description',

  supporting_evidence: 'supporting_evidence',
  file: 'file',
  additional_info: 'additional_info',
  submit: 'submit',
};

export const defaultValues = {
  [FIELD_NAMES.name]: '',
  [FIELD_NAMES.email]: '',
  [FIELD_NAMES.address_1]: '',
  [FIELD_NAMES.address_2]: '',
  [FIELD_NAMES.postcode]: '',
  [FIELD_NAMES.city]: '',
  [FIELD_NAMES.country]: {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
  },

  [FIELD_NAMES.product]: undefined,
  [FIELD_NAMES.description]: '',

  [FIELD_NAMES.supporting_evidence]: '',
  [FIELD_NAMES.file]: null,
  [FIELD_NAMES.additional_info]: '',
  [FIELD_NAMES.submit]: false,
};
const FILE_SIZE = 5242880; //5MB
const FILE_TYPES = ['image/jpeg', 'image/png', '.pdf', 'application/pdf'];

const schema = yup.object().shape({
  [FIELD_NAMES.name]: yup.string().required(TEXT.errors[FIELD_NAMES.name]),
  [FIELD_NAMES.email]: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
  [FIELD_NAMES.address_1]: yup.string().required(TEXT.errors.address),
  [FIELD_NAMES.address_2]: yup.string(),
  [FIELD_NAMES.postcode]: yup.string(),
  [FIELD_NAMES.city]: yup.string().required(TEXT.errors.city.required),
  [FIELD_NAMES.country]: yup.object().shape({
    name: yup.string().required(TEXT.errors.country.required),
    dial_code: yup.string(),
    code: yup.string(),
  }),
  [FIELD_NAMES.product]: yup.string().nullable().required(TEXT.errors.product),
  [FIELD_NAMES.file]: yup
    .mixed()
    .nullable()
    .test('size', TEXT.errors.file.max, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && value.size <= FILE_SIZE;
      }
    })
    .test('type', TEXT.errors.file.type, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && FILE_TYPES.indexOf(value.type) > -1;
      }
    }),
  [FIELD_NAMES.additional_info]: yup.string(),
  [FIELD_NAMES.supporting_evidence]: yup
    .object()
    .shape({ label: yup.string(), value: yup.string() })
    .nullable()
    .required(TEXT.errors.product),
  [FIELD_NAMES.submit]: yup.boolean(),
});

export default schema;
